import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import useEvaluationActions from "../../../api/hooks/rater/evaluation";
import {
  evaluateArrayIndexSelector,
  evaluationItemsState,
  raterCommentListState,
} from "../../../recoil/rater/evaluation";

const RaterComment = ({ params }) => {
  const [raterCommentList, setRaterCommentList] = useRecoilState(
    raterCommentListState
  );
  const evaluationActions = useEvaluationActions();
  const [comment, setComment] = useState("");
  const evaluationItems = useRecoilValue(evaluationItemsState);
  const evaluateArrayIndex = useRecoilValue(evaluateArrayIndexSelector);

  const addComment = async (comment) => {
    //코멘트가 존재 할 시
    if (comment) {
      setComment("");
      const res = await evaluationActions.postRaterComment({ comment });

      getComment();
    }
  };

  useEffect(() => {
    getComment();
  }, [evaluationItems, evaluateArrayIndex, params]);

  const getComment = async () => {
    setRaterCommentList([]);
    const res = await evaluationActions.getRaterCommentList(params);
    if (res.status === 200) {
      setRaterCommentList(res.data);
    }
  };
  return (
    <div>
      <div className="rater-opinion-box">
        <div className="evalation-box">
          <div className="evalation-title">
            <p>평가자 의견교환</p>
          </div>
        </div>
        {!params && (
          <>
            <div className="border-line"></div>
            <div className="comment-box text-align-right">
              <textarea
                placeholder="코멘트 남기기"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
              <button
                type="button"
                className="comment-insert-btn"
                onClick={() => addComment(comment)}
              >
                등록
              </button>
            </div>
          </>
        )}
      </div>
      <div className="overflow-scroll height-486">
        {raterCommentList?.map((comment, i) => {
          return (
            <div className="comment-show" key={i}>
              <p className="grade-admin">
                <span className="comment-user">{comment.name}</span>
                <span className="commnet-date">
                  {dayjs(comment.date).format("YYYY/MM/DD HH:mm")}
                </span>
              </p>
              <p className="comment-cont">{comment.comment}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RaterComment;
